<template>
  <div style="width: 100%; height: auto; margin-top: 60px; font-family: 黑体;  ">
    <p id="title" style="font-size: 18px;font-weight: bold; color: white; margin-left: 10px;">各站点设备情况</p>
    <div id="SubLeftThreeHeader" style="width: 105%; height: 30px; margin-left: 10px; margin-top: 10px; font-size: 20px;">
      <table>
        <thead>
        <tr>
          <th style=" display: inline-block; width: 130px; !important;">站点名称</th>
          <th>设备供电</th>
          <th>设备开机</th>
          <th>监测在线</th>
          <th>监测分贝</th>
        </tr>
        </thead>
      </table>
    </div>
    <div id="SubLeftThreeContent" style="width: 105%; height: 220px; margin-left: 10px; overflow-y: scroll;    background-color: #26374b;">
      <table>
        <tbody>
        <tr v-for="item in tableData">
          <th class="f-els3" style="display: inline-block;" :title="item.pointName">{{item.pointName}}</th>
<!--          <th>{{ item.CE ? "是":"否"}}</th>-->
          <th v-if="item.CE"><i class="el-icon-circle-check" style="color: lightgreen;"></i></th>
          <th v-else><i class="el-icon-circle-close" style="color: red;"></i></th>
<!--          <th>{{item.on ? "是": "否"}}</th>-->
          <th v-if="item.on"><i class="el-icon-circle-check" style="color: lightgreen;"></i></th>
          <th v-else><i class="el-icon-circle-close" style="color: red;"></i></th>
<!--          <th>{{item.online ? "是":"否"}}</th>-->
          <th v-if="item.onLine"><i class="el-icon-circle-check" style="color: lightgreen;"></i></th>
          <th v-else><i class="el-icon-circle-close" style="color: red;"></i></th>
<!--          <th>{{item.alarm ? "是": "否"}}</th>-->
          <th v-if="item.alarm"><i class="el-icon-warning-outline" style="color: red;"></i></th>
          <th v-else><i class="el-icon-circle-check" style="color: lightgreen;"></i></th>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SubLeftTwo2',
    props: ['areaId'],
    data(){
      return {
        interval:null, // 轮询
        tableData:[],
        AreaDevScreen:{
          "version": 1,
          "method": "synthScreen.AreaDevScreen",
          "params": {
            "areaId":"0",
          },
          "token": "",
          "id": 0
        },
      }
    },
    methods:{
      getAreaDevScreen(){
        this.AreaDevScreen.token = this.$store.state.token;
        this.AreaDevScreen.params.areaId = this.areaId;
        console.log('获取各区设备情况');
        console.log(this.AreaDevScreen);
        this.$axios.post(this.$newMainUrl, this.AreaDevScreen).then(res=> {
          // this.$message({
          //   type: 'success',
          //   message: '刷新'
          // })
          console.log('获取各区设备情况请求得到响应');
          console.log(res.data);
          // 让数值与列所表示的区对应，所以要规定顺序
          if(res.data.hasOwnProperty('result')){
            this.tableData = res.data.result.devStaAll;
          }else{
            this.$message({
              type:'error',
              message:'获取警报点静态信息失败，' + res.data.error.message
            })
          }
        })
      },
    },
    mounted(){
      this.getAreaDevScreen();
      this.interval = setInterval(()=>{
        this.getAreaDevScreen();
      }, 3000);
    },
    destroyed(){
      clearInterval(this.interval);
      // this.$message({
      //   type: 'error',
      //   message: '结束'
      // })
    }
  }
</script>

<style scoped lang="scss">
  #SubLeftThreeHeader, #SubLeftThreeContent{
    table{
      text-align: center;
      /*table-layout:fixed;*/
      color: white;
      font-size: 18px;
      transform: scale(1.0);
      width: 100%;
      border-collapse: collapse;
      /*colgroup{*/
      /*  col:nth-child(1){*/
      /*    width: 30px;*/
      /*  }*/
      /*  col:nth-child(2){*/
      /*    width: 20px;*/
      /*  }*/
      /*}*/
      tr{
        background-color: #26374b;
        line-height: 30px;
        th:nth-child(1), td:nth-child(1){
          width: 6em;
        }
        th:nth-child(2), td:nth-child(2){
          width: 5em;
        }
        th:nth-child(3), td:nth-child(3){
          width: 5em;
        }
        th:nth-child(4), td:nth-child(4){
          width: 5em;
        }
        th:nth-child(5), td:nth-child(5){
          width: 5em;
        }
      }
    };
  }
  #SubLeftThreeHeader tr:first-child{
    background-color: #213380;
    font-size: 16px;
    line-height: 30px;
  }
</style>
<style>
  #SubLeftThreeContent::-webkit-scrollbar{
    display: none;
  }
  #SubLeftThreeContent{
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  i.Yes{
    color: lightgreen;
  }
  i.No{
    color: red;
  }
  .f-els3{width: 6rem; overflow: hidden;text-overflow:ellipsis;white-space: nowrap;text-align: left; margin-left: 10px;}
</style>
